// StyledDescription.js
import styled from "styled-components";

import React, { useContext } from "react";

import { FormBuilderContext } from "../context/context";
const StyledDescriptionBase = styled.label`
  outline: none;
  padding: 0 ${({ styling }) => `${styling.descriptionPaddingInline}px`};
  font-size: ${({ styling }) => `${styling.descriptionFontSize}px`};
  font-weight: ${({ styling }) => styling.descriptionFontWeight};
  font-family: ${({ styling }) => styling.descriptionFontFamily};
  transition: ${(props) => props.theme.transitionMain};
  margin-top: ${({ styling }) => styling.descriptionTopSpacing}px;
  color: ${({ styling }) => styling.descriptionColor};
`;

const StyledDescription = (props) => {
  const { state } = useContext(FormBuilderContext);
  const placeholderText = state.addPlaceholders ? "Example Text" : "";

  return <StyledDescriptionBase {...props} placeholder={placeholderText} />;
};



export default StyledDescription;
